// extracted by mini-css-extract-plugin
export default {"desc":"Desc_desc__BXYQX","marquee":"Desc_marquee__iW5Mb","track":"Desc_track__J45yR","textContainer":"Desc_textContainer__CFQvp","textContainer2":"Desc_textContainer2__x-ORk"};